<template>
  <component :is="queryComponent" v-bind="$attrs" ref="child">
    <slot></slot>
  </component>
</template>

<script>
import {
  defineComponent, inject, provide, ref,
} from 'vue';
import QueryComponents from './search-item';

const Query = defineComponent({
  props: {
    kind: {
      type: String,
      required: true,
    },
    keyName: String,
  },
  name: 'yx-query',
  setup(props) {
    const inGroup = inject('is-yx-query-group');
    provide('is-yx-query', true);

    // 如果不在group里
    if (inGroup !== true) {
      throw new Error('yx-query组件不在yx-query-group组件里');
    }

    // eslint-disable-next-line vue/no-setup-props-destructure
    const { kind, keyName } = props;

    // 校验kind可正常渲染.
    if (!QueryComponents[kind]) {
      throw new Error('yx-query组件提供的kind不对', kind);
    }

    if (keyName) {
      const useQuery = inject('useQuery');
      provide('useQuery', (key, ...args) => useQuery(keyName, ...args));
    }

    const child = ref(null);
    return {
      child,
      queryComponent: QueryComponents[kind],
    };
  },
});
export default Query;
</script>

<style lang="scss" scoped></style>
